import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import styles from './TestStatusModal.module.css';
import { ToastContainer, toast, cssTransition } from "react-toastify";
import Loader from '../Loader';

Modal.setAppElement('#root'); // Ensure accessibility

function TestStatusModal({ isOpen, onRequestClose, test, handleTestStatus, handleFileUpload, readOnly }) {
  const [testStatus, setTestStatus] = useState(test.testStatus || "Pending");
  const [rejectionReason, setRejectionReason] = useState(test.rejectionReason || "");
  const [reportUrl, setReportUrl] = useState(test.reportUrl || "");
  const [fileName, setFileName] = useState('');
  const [isUploadingAgain, setIsUploadingAgain] = useState(false);
  const [resonforReupload, setUploadReason] = useState('');
  const [hasUploaded, setHasUploaded] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [fileUploadStatus, setFileUploadStatus] = useState('idle'); // idle, uploading, success, error
  const fileInputRef = useRef(null);
  const [isReplacing, setIsReplacing] = useState(false);
  console.log("testinsidetestmodal",test)

 function getFileNameFromUrl(url) {
  const fullFileName = url.split('/').pop().split('?')[0]; // Extract actual file name
  const decodedFileName = decodeURIComponent(fullFileName); // Decode %20 to spaces, etc.
  const nameWithoutExt = decodedFileName.replace(/\.[^/.]+$/, ""); // Remove extension
  const baseName = nameWithoutExt.split('-')[0]; // Split at first '-' and get base
  console.log("basenameforfile", baseName);
  return `${baseName.trim()}.pdf`; // Trim to remove any trailing space
}
  useEffect(() => {
    setTestStatus(test.testStatus || "Pending");
    setRejectionReason(test.rejectionReason || "");
    setReportUrl(test.reportUrl || "");
    setUploadReason(test.resonforReupload || "");
    setIsUploadingAgain(false); 
    setHasUploaded(false);
    setIsUploading(false);
    setUploadError('');
    setFileUploadStatus('idle');
    if (test.reportUrl) {

      console.log("test.reportUrl",test.reportUrl)
      setFileName(getFileNameFromUrl(test.reportUrl));
      setFileUploadStatus('success');
    } else {
      setFileName("");
      setFileUploadStatus('idle');
    }
  }, [test]);

  const handleStatusChange = (e) => {
    setTestStatus(e.target.value);
  };

  const handleRejectionReasonChange = (e) => {
    setRejectionReason(e.target.value);
  };

  const handleFileChange = async (e) => {
    // user selected a file (or change event fired) - exit replacing state
    setIsReplacing(false);
    const file = e.target.files[0];
    if (!file) return;

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      setUploadError('File size must be less than 10MB');
      setFileUploadStatus('error');
      return;
    }

    // Validate file type (only PDF, images)
    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      setUploadError('Only PDF and image files (PNG, JPG) are allowed');
      setFileUploadStatus('error');
      return;
    }

    setIsUploading(true);
    setFileUploadStatus('uploading');
    setUploadError('');
    setFileName(file.name);

    try {
      // Check if there was already a report before this upload (RE-UPLOAD scenario)
      const hadPreviousReport = test.reportUrl && test.reportUrl !== "";
      
      const result = await handleFileUpload(test.id, test.SalesEntry.PatientFullName, test.test, test.SalesEntry.id, file);
      
      if (result.success) {
        setReportUrl(result.filePath);
        setFileUploadStatus('success');
        toast.success(result.message);
        // Only set isUploadingAgain to true if this is a replacement of existing file
        setIsUploadingAgain(hadPreviousReport);
        setHasUploaded(true);
        setUploadError('');
      } else {
        setFileUploadStatus('error');
        setUploadError(result.error || 'Failed to upload file');
        toast.error(result.error || 'Failed to upload file');
        setFileName('');
        setReportUrl('');
      }
    } catch (error) {
      setFileUploadStatus('error');
      setUploadError('An unexpected error occurred during upload');
      toast.error('An unexpected error occurred during upload');
      setFileName('');
      setReportUrl('');
    } finally {
      setIsUploading(false);
      // ensure replacing flag is cleared after operation
      setIsReplacing(false);
    }
  };

  const handleSubmit = () => {
    console.log("resonforReupload submit", resonforReupload);
    console.log("testStatus",testStatus)

    if(testStatus==="Pending"){
      toast.error("Test status is mandatory");
      return
    }
    if(reportUrl===""){
      toast.error("Please upload test Report");
      return
    }
    if(fileUploadStatus !== 'success'){
      toast.error("Please wait for the file to upload successfully before submitting");
      return
    }
    if(isUploadingAgain && !resonforReupload.trim()){
      toast.error("Please provide a note for re-upload");
      return
    }
    
    handleTestStatus(test.id, {
      status: testStatus,
      rejectionReason,
      resonforReupload,
    });
 

      onRequestClose();
    
   
  };

  const handleUploadReasonChange = (e) => {
    setUploadReason(e.target.value);
    console.log("reason for reupload", e.target.value);
    console.log("resonforReupload", resonforReupload);
  };

  const handleReplaceFile = () => {
    // mark that user initiated a replace; keep existing preview until new file selected
    setUploadError('');
    setIsReplacing(true);
    // fallback: if user cancels file picker, clear replacing flag after 8s
    const clearTimer = setTimeout(() => setIsReplacing(false), 8000);
    // Reset and trigger the file input via ref (safer than getElementById)
    if (fileInputRef.current) {
      // Avoid directly setting .value to prevent null/readonly errors in some environments
      try {
        fileInputRef.current.click();
      } catch (e) {
        // ignore
      }
    } else {
      // fallback: create a temporary input and click it
      const tmp = document.createElement('input');
      tmp.type = 'file';
      tmp.accept = '.pdf,.png,.jpg,.jpeg';
      tmp.style.display = 'none';
      document.body.appendChild(tmp);
      tmp.addEventListener('change', (e) => {
        if (e.target.files && e.target.files[0]) {
          // forward to existing handler
          handleFileChange({ target: tmp });
        }
        setTimeout(() => document.body.removeChild(tmp), 0);
      });
      tmp.click();
    }
    // clear the timer when modal loses focus or input changed
    const cleanup = () => {
      clearTimeout(clearTimer);
      window.removeEventListener('focus', cleanup);
    };
    window.addEventListener('focus', cleanup);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content"
      overlayClassName="modal-overlay"
    >
        {/* <ToastContainer position="bottom-right" autoClose={2000} /> */}
      <h2 style={{ marginTop: '0px', marginBottom: '0px' }}>Test Report Status</h2>
      <hr style={{ marginTop: '0px' }}></hr>
      <button className={styles['close-button']} onClick={onRequestClose}>×</button>
      <form className="modal-form">
        <div className="form-group">
          <label>Status:</label>
          <select value={testStatus} onChange={handleStatusChange} disabled={readOnly}>
            <option value="Pending">Pending</option>
            <option value="Accepted">Reported</option>
            {/* <option value="Rejected">Rejected</option> */}
          </select>
        </div>
        {testStatus === "Rejected" && (
          <div className="form-group">
            <label>Reason for Rejection:</label>
            <textarea value={rejectionReason} onChange={handleRejectionReasonChange} disabled={readOnly}></textarea>
          </div>
        )}
        <div className="form-group">
          <label>Upload Report:</label>
          <input
            id="fileInput"
            ref={fileInputRef}
            type="file"
            onChange={handleFileChange}
            disabled={isUploading}
            accept=".pdf,.png,.jpg,.jpeg"
            // keep the input rendered so ref is available; when a file exists
            // visually hide it off-screen instead of display:none so click() opens picker
            style={
              (fileUploadStatus === 'success' && !isReplacing) || isReplacing
                ? { position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden', opacity: 0 }
                : undefined
            }
          />
          {isUploading && (
            <div className={styles['upload-status']}>
              <div className={styles['uploading']}>
                <Loader />
                <span>Uploading file... Please wait</span>
              </div>
            </div>
          )}
          {uploadError && (
            <div className={styles['upload-error']}>
              <span>❌ {uploadError}</span>
              <small>Please try again with a valid file</small>
            </div>
          )}
          {fileUploadStatus === 'success' && reportUrl && (
            <div className={styles['upload-success']}>
              <div className={styles['success-message']}>
                <span>✓ File uploaded successfully</span>
              </div>
              <a href={reportUrl} target="_blank" rel="noopener noreferrer" className={styles['file-link']}>
                📄 View Uploaded Report - {fileName}
              </a>
              <button 
                type="button"
                className={styles['replace-file-btn']}
                onClick={handleReplaceFile}
                disabled={isUploading}
              >
                Replace File
              </button>
            </div>
          )}
          {!reportUrl && fileUploadStatus === 'idle' && (
            <div className={styles['upload-info']}>
              <small>📁 Supported formats: PDF, PNG, JPG (Max 10MB)</small>
            </div>
          )}
        </div>

        {/* Show reason input only if a report was previously uploaded */}
        {isUploadingAgain && (
          <div className="form-group">
            <label>Note for Re-upload: <span className={styles['required-field']}>*</span></label>
            <textarea
              value={resonforReupload}
              onChange={handleUploadReasonChange}
              placeholder="Please provide details about this re-upload (e.g., file quality improved, corrected data, etc.)"
              required
              className={styles['reason-textarea']}
            />
            {!resonforReupload.trim() && isUploadingAgain && (
              <small className={styles['validation-error']}>Please provide a note explaining the re-upload</small>
            )}
          </div>
        )}
     
      
      </form>
      <button
        className={styles['submit-button']}
        onClick={handleSubmit}
        disabled={isUploading || !reportUrl || fileUploadStatus !== 'success'}
        title={isUploading ? "Please wait for upload to complete" : !reportUrl ? "Please upload a report" : ""}
      >
        {isUploading ? 'Uploading...' : 'Submit'}
      </button>
    </Modal>
  );
}

export default TestStatusModal;
